const isElectron = () => navigator.userAgent.indexOf('Electron') >= 0;


const ScrollToActive = (el?: any) => {
	const activeItem = el?.querySelector('.item-active');

	if(!ElementInView(activeItem)) {
		activeItem?.scrollIntoView({
			behavior: "smooth",
			block: "end",
		})
	}
}

const GroupBy = (object: any, key: any) : any => {
	const map = new Map();

	object.forEach((item: any) => {
		const groupKey = key(item);
		const collection = map.get(groupKey);

		if (!collection) {
			map.set(groupKey, [item]);
		} else {
			collection.push(item);
		}
	});

	return map;
}

const GroupByMatchedOnly = (object: any, key: any) : any => {
	const map = new Map();

	object.forEach((item: any) => {
		const groupKey = key(item);
		const collection = map.get(groupKey);

		if(groupKey) {
			if (!collection) {
				map.set(groupKey, [item]);
			} else {
				collection.push(item);
			}
		}
	});

	return map;
}

const GetObjectIndexByKeyValue = (object: any, key: string, value: any | null, keyNext?: string) => {
	if(!object || value === null) return -1;

	if(typeof(object) !== 'object') {
		console.warn('GetObjectIndexByKeyValue object is not and object');
		return -1;
	}

	return object.findIndex((item: any) => {
		return keyNext ? item[key][keyNext] === value : item[key] === value;
	});
};

const FilterInPlace = (array: any, key: string, val: string) => {
	const index = GetObjectIndexByKeyValue(array, key, val);
	const newArray = array;

	if (index > -1) {
		newArray.splice(index, 1);
	}
	return newArray;
};

const GetReadableFileSize = (input: number) => {
	const i: number = Math.floor( Math.log(input) / Math.log(1024));

	const value = parseFloat((input / Math.pow(1024, i)).toFixed(2));

	if(isNaN(value)) {
		return `0B`;
	}

	return `${value}${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
}

const StripHtml = (input: string) => {
	if (!input || input === '') return input;
	return input
		.replace('\n', '')
		.replace(/<(?:br|\/div|\/p)>/g, '\n')
		.replace(/<.*?>/g, '')
		.trim();
};

const GetItemIndex = (object: any, key: string, value: any | null) => {
	if(!object || !value) return -1;
	return object.findIndex((item: any) => item[key] === value);
}

const GetLanguage = (tryRegion: boolean = false) => {
	return tryRegion? navigator.language.split('-')[0].toUpperCase() : navigator.language;
}

const HasLowerCase = (str: string) => {
	return (/[a-z]/.test(str));
}

const HasUpperCase = (str: string) => {
	return (/[A-Z]/.test(str));
}

const HasNumber = (str: string) => {
	return (/[1-9]/.test(str));
}

const ElementInView = (el: Element | undefined | null) => {
	if(!el) return null;

	const rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

const ElementUnderPointer = (x:number, y: number) : Element | null => {
	return document.elementFromPoint(x, y);
}

const FormatCurrency = (value: any, hideDecimal?: boolean) => {
	const formatter = new Intl.NumberFormat('en-GB', {
		style: 'currency',
		currency: 'GBP',
		minimumFractionDigits: hideDecimal ? 0 : 2,
	});

	return formatter.format(value)
}

const RandomNumber = (min: number, max: number) => {
	return Math.floor(Math.random() * (max - min + 1) + min)
}

const FilterUniqueArrayEntries = (array: Array<any>) => {
	return array.filter((v, i, a) => a.indexOf(v) === i);
}

const FilterUniqueObjectEntries = (array: Array<any>, uniqueKey: string) => {
	return Array.from(new Map(array.map(item => [item[uniqueKey], item])).values())
}

const PercentOf = (value: number, total: number) => {
	return (100 * value) / total;
}

const Debounce = (fn: any, delay: number) => {
	let timerId: any;

	return (...args : any) => {
		clearTimeout(timerId);
		timerId = setTimeout(() => fn(...args), delay);
	}
};

const ParseURL = (slug: string) => {
	return `${window.location.protocol}//${window.location.host}${slug}`;
}

const GetInitials = (value: string) => {
	const parts = value.split(' ');
	let initials = '';

	for (let i = 0; i < parts.length; i++) {
		if (parts[i].length > 0 && parts[i] !== '') {
			initials += parts[i][0]
		}
	}

	return initials.toUpperCase();
}

export { GetInitials, ParseURL, Debounce, ScrollToActive, PercentOf, FilterUniqueArrayEntries, FilterUniqueObjectEntries, RandomNumber, FormatCurrency, ElementUnderPointer, ElementInView, GroupBy, GroupByMatchedOnly, StripHtml, GetReadableFileSize, FilterInPlace, GetObjectIndexByKeyValue, GetItemIndex, isElectron, GetLanguage, HasLowerCase, HasUpperCase, HasNumber };